<form [formGroup]="pricingForm" (ngSubmit)="save()" class="pricing-settings-form">
  <mat-form-field style="width:100%;">
    <span matPrefix>$&nbsp;</span>
    <input matInput type="number" min="0" step="0.01" formControlName="dutyAmount" placeholder="DUTY">
    <mat-hint>Flat fee added to Custom when duty is selected on an order</mat-hint>
  </mat-form-field>
  <mat-form-field style="width:100%;">
    <span matPrefix>$&nbsp;</span>
    <input matInput type="number" min="0" step="0.01" formControlName="nosepadsInstallAmount" placeholder="NOSEPADS INSTALL">
    <mat-hint>Flat fee added to Custom when nosepads install is selected on an order</mat-hint>
  </mat-form-field>
  <mat-form-field style="width:100%;">
    <span matPrefix>$&nbsp;</span>
    <input matInput type="number" min="0" step="0.01" formControlName="drillMountAmount" placeholder="DRILL MOUNT">
    <mat-hint>Flat fee added to Custom when drill mount is selected on an order</mat-hint>
  </mat-form-field>
  <mat-form-field style="width:100%;">
    <input matInput type="number" min="0" max="100" step="0.01" formControlName="restockingFeePercent" placeholder="RESTOCKING FEE %">
    <span matSuffix>&nbsp;%</span>
    <mat-hint>Default restocking fee applied on RETURN. Opticians can waive it per return.</mat-hint>
  </mat-form-field>
  <mat-form-field style="width:100%;">
    <input matInput type="number" min="0" max="100" step="0.01" formControlName="salesTaxRate" placeholder="SALES TAX %">
    <span matSuffix>&nbsp;%</span>
    <mat-hint>Applied to taxable line items after discounts. Postage is not discounted. Leave 0 to use the TAX amount entered on the order.</mat-hint>
  </mat-form-field>

  <div class="materials-section" formArrayName="materials">
    <div class="materials-header">
      <h3 class="materials-title">MATERIALS</h3>
      <button mat-stroked-button type="button" (click)="addMaterial()">ADD OPTION</button>
    </div>
    <p class="materials-hint">
      Options appear in the Material dropdown on Add Order. Selected material price is added to Custom.
    </p>

    <div
      class="material-row"
      *ngFor="let material of materials.controls; let i = index"
      [formGroupName]="i"
    >
      <mat-form-field class="material-label-field">
        <mat-label>LABEL</mat-label>
        <input matInput formControlName="label" autocomplete="off">
      </mat-form-field>
      <mat-form-field class="material-price-field">
        <mat-label>PRICE</mat-label>
        <span matPrefix>$&nbsp;</span>
        <input
          matInput
          type="text"
          inputmode="decimal"
          formControlName="price"
          autocomplete="off"
          (blur)="formatMaterialPrice(i)"
        >
      </mat-form-field>
      <button
        mat-icon-button
        type="button"
        color="warn"
        aria-label="Remove material option"
        (click)="removeMaterial(i)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>

    <div class="materials-empty" *ngIf="!materials.length">
      No material options yet. Click ADD OPTION to create one.
    </div>
  </div>

  <button mat-raised-button type="submit" [disabled]="pricingForm.invalid || saving">SAVE</button>
</form>
